import { Spacing } from '@billy/design-system'
import { StyleSheet } from '@react-pdf/renderer'

export const AmountCellsStyles = StyleSheet.create({
  amountsGroup: {
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: Spacing.S8,
  },
  amountColumn: {
    minWidth: 56,
    alignItems: 'flex-end',
  },
  amountText: {
    fontSize: '10px',
    textAlign: 'right',
  },
})
